import angular from 'angular';

import projectsScope from './projecs-scope';
import widgetsLibrary from './widgets-library';
import widgets from './widgets';
import graphs from './graphs';
import summaryBlock from './summary-block';
import toolbox from './toolbox';

export default angular.module('dbm.dashboard.components', [
    graphs,
    widgets,
    projectsScope,
    widgetsLibrary,
    summaryBlock,
    toolbox
]).name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/index.js